(() => {
  const root = document.querySelector('.fs-listicle');
  if (!root) return;
  const query = new URLSearchParams(window.location.search);
  const attributionKeys = new Set(['fbclid', 'campaign_id', 'adset_id', 'ad_id', 'fs_release', 'fs_creative', 'fs_landing']);
  // Carry campaign attribution into the unchanged paid offer; model is explicit.
  root.querySelectorAll('[data-fs-listicle-model]').forEach(link => {
    const target = new URL(link.getAttribute('href'), window.location.origin);
    for (const [key, value] of query) {
      if (/^utm_[a-z_]+$/i.test(key) || attributionKeys.has(key)) target.searchParams.set(key, value);
    }
    link.href = target.pathname + target.search;
  });
  const rail = root.querySelector('.fs-l__sticky');
  // A virtual keyboard must not trap footer or focused controls behind the rail.
  const viewport = window.visualViewport;
  if (rail && viewport) {
    const resize = () => { rail.hidden = viewport.height < window.innerHeight * 0.7; };
    viewport.addEventListener('resize', resize, {passive:true});
    resize();
  }
})();
